import I from '../types.ts';

const searchHandler: I['searchHandler'] = function ({ value }) {
    const search = value as string;

    return new Promise((resolve) => {
        const isUpdate = search.length > 2 || (search.length <= 2 && this.state.search?.length > 2);

        this.setState({ search, isLoadingFilter: isUpdate }, () => {
            if (isUpdate) {
                clearTimeout(this.searchTimerId);

                this.searchTimerId = setTimeout(() => {
                    this.updateItems();
                }, 300);
            }

            resolve();
        });
    });
};

export default searchHandler;
